// extracted by mini-css-extract-plugin
module.exports = {"story-element-container":"errors_story-element-container__1YKNi","story-element-left-pan":"errors_story-element-left-pan__IEc4w"};